import {useState, useEffect} from 'react'
import {screenSizes} from 'hec/config/breakpoints'
import {isClient} from '@/utils/common'

const useMediaQuery = (size) => {
    const query = screenSizes[size]

    const [matches, setMatches] = useState(() => {
        // Return `false` on the server (SSR) and set the initial state accordingly on the client
        if (isClient && query) {
            return window.matchMedia(query).matches
        }
        return false
    })

    useEffect(() => {
        if (typeof window === 'undefined' || !query) return

        const mediaQueryList = window.matchMedia(query)

        const handleChange = (event) => setMatches(event.matches)

        // Initial check and listener setup
        handleChange(mediaQueryList)
        mediaQueryList.addEventListener('change', handleChange)

        // Cleanup on unmount
        return () => mediaQueryList.removeEventListener('change', handleChange)
    }, [query])

    return matches
}

export default useMediaQuery
